"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapButton = void 0;
const react_1 = __importDefault(require("react"));
const S = __importStar(require("./MapButtons.style"));
const MapButton = react_1.default.forwardRef(({ image, title, alt, onClick, isActive, isDisabled, className }, ref) => {
    return (react_1.default.createElement(S.MapButton, { onClick: onClick, "$isActive": isActive, "$isDisabled": isDisabled, className: className },
        react_1.default.createElement(S.Title, { "$isActive": isActive }, title),
        react_1.default.createElement(S.IconWrapper, { "$src": image, "$isActive": isActive, title: alt })));
});
exports.MapButton = MapButton;
